<div class="container">
  <div class="content">
    <div class="custom-flex-row flex-gap-px-8 ion-align-items-center">
      <fa-icon style="color: #EF5350;" [icon]="faExclamationTriangle"></fa-icon>
      <span class="fs-px-20 text-secondary font-bold">Attention!</span>
    </div>

    <p [innerHTML]="content"></p>
  </div>

  <div class="footer" *ngIf="footerButtons.length">
    <div class="custom-flex-row flex-gap-px-8 ion-align-items-center">
      <div class="grow" *ngFor="let btn of footerButtons; index as idx">
        <ion-button mode="md" expand="block"
                    [color]="btn.color ?? 'dark'"
                    (click)="onFooterBtnClick(idx)">
          <div class="custom-flex-row flex-gap-px-4 ion-align-items-center">
            <span>{{btn.text}}</span>
            <fa-icon *ngIf="btn.icon as icon" [icon]="icon"></fa-icon>
          </div>
        </ion-button>
      </div>
    </div>
  </div>
</div>